/* WinBoost AI Phone configurator.
   Prices come from Shopify (each combination is a real variant with its own price), never from this script:
   this file only finds the matching variant, shows the total and savings, and adds the items to the cart. */
(function () {
  'use strict';
  var root = document.querySelector('[data-wb-cfg]');
  if (!root) return;

  var variants = JSON.parse(document.getElementById('wb-variants').textContent);
  var locEl = document.getElementById('wb-loc-variants');
  var locVariants = locEl ? JSON.parse(locEl.textContent) : [];
  var smsList = Math.round(Number(root.getAttribute('data-sms-list') || 0) * 100); // cents
  var LOCALE = 'en-CA';
  var money = function (c) { return Math.round(c / 100).toLocaleString(LOCALE) + "\u00a0$"; };
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  var NOT = 'Not included', YES = 'Included';
  function find(phone, sms, orbit) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.o[0] === phone && v.o[1] === (sms ? YES : NOT) && v.o[2] === (orbit ? YES : NOT)) return v;
    }
    return null;
  }
  var price = function (v) { return v ? v.p : 0; };
  var base = { In: price(find('Inbound', 0, 0)), Out: price(find('Outbound', 0, 0)), Orbit: price(find('None', 0, 1)) };

  var st = { phone: 'Inbound', sms: false, orbit: false, locQty: 0, locType: 'Inbound', number: '' };

  // Deep links from the collection page: ?phone=Inbound+%2B+Outbound&sms=1&orbit=1&locs=2
  (function preset() {
    var q = new URLSearchParams(location.search);
    var p = q.get('phone');
    if (p && $('input[name="phone"][value="' + p.replace(/"/g, '') + '"]')) st.phone = p;
    if (q.get('sms') === '1' && st.phone !== 'None') st.sms = true;
    if (q.get('orbit') === '1') st.orbit = true;
    var l = parseInt(q.get('locs'), 10);
    if (l > 0 && locVariants.length) st.locQty = Math.min(l, 99);
    var t = q.get('loctype');
    if (t === 'Outbound') st.locType = 'Outbound';
  })();

  function locVariant() {
    for (var i = 0; i < locVariants.length; i++) if (locVariants[i].o[0] === st.locType) return locVariants[i];
    return null;
  }

  function current() {
    var main = (st.phone === 'None' && !st.orbit) ? null : find(st.phone, st.sms && st.phone !== 'None', st.orbit);
    var lv = locVariant();
    var items = [];
    if (main) items.push({ id: main.id, quantity: 1 });
    if (lv && st.locQty > 0) items.push({ id: lv.id, quantity: st.locQty });
    return { main: main, lv: lv, items: items };
  }

  function render() {
    // keep controls in sync with state
    $$('input[name="phone"]').forEach(function (r) { r.checked = r.value === st.phone; });
    var sms = $('input[name="sms"]'), orb = $('input[name="orbit"]');
    if (sms) { sms.disabled = st.phone === 'None'; if (sms.disabled) st.sms = false; sms.checked = st.sms; }
    if (orb) orb.checked = st.orbit;
    var out = $('[data-loc-qty]'); if (out) out.textContent = st.locQty;
    var ls = $('select[name="loctype"]'); if (ls) ls.value = st.locType;

    var c = current(), lines = [], list = 0, total = 0;
    if (c.main) {
      total += c.main.p;
      if (st.phone.indexOf('Inbound') > -1) { list += base.In; lines.push(['AI Phone appels entrants', base.In]); }
      if (st.phone.indexOf('Outbound') > -1) { list += base.Out; lines.push(['AI Phone appels sortants', base.Out]); }
      if (st.sms && st.phone !== 'None') { list += smsList; lines.push(['AI Phone d\u2019avis par SMS', smsList]); }
      if (st.orbit) { list += base.Orbit; lines.push(['Active AI Orbit', base.Orbit]); }
    }
    var saving = Math.max(0, list - total);
    var locTotal = 0, locSaving = 0;
    if (c.lv && st.locQty > 0) {
      locTotal = c.lv.p * st.locQty;
      var first = st.locType === 'Outbound' ? base.Out : base.In;
      locSaving = Math.max(0, (first - c.lv.p) * st.locQty);
    }

    var html = '';
    if (!c.main && !(c.lv && st.locQty > 0)) html = '<div class="wbs-line empty"><span>Choisissez un AI Phone ou l\u2019Active AI Orbit pour commencer.</span></div>';
    lines.forEach(function (l) { html += '<div class="wbs-line"><span>' + l[0] + '</span><span>' + money(l[1]) + '</span></div>'; });
    if (saving > 0) html += '<div class="wbs-line save"><span>\u00c9conomies de l\u2019ensemble</span><span>&minus;' + money(saving) + '</span></div>';
    if (c.lv && st.locQty > 0) {
      html += '<div class="wbs-line"><span>Emplacement suppl\u00e9mentaire ' + st.locType + ' AI Phone &times; ' + st.locQty + '</span><span>' + money(locTotal) + '</span></div>';
      if (locSaving > 0) html += '<div class="wbs-line save"><span>\u00c9conomies multi-emplacements incluses</span><span>' + money(locSaving) + '</span></div>';
    }
    $('[data-lines]').innerHTML = html;
    var grand = total + locTotal;
    $$('[data-total]').forEach(function (e) { e.textContent = money(grand); });
    var youSave = saving + locSaving;
    var sv = $('[data-yousave]'); if (sv) sv.textContent = youSave > 0 ? 'Vous \u00e9conomisez ' + money(youSave) : '';
    $$('[data-add]').forEach(function (b) { b.disabled = !c.items.length; });
    var cp = $('[data-copy]'); if (cp) cp.disabled = !c.items.length;
    var np = $('[data-number-wrap]');
    if (np) np.hidden = !(c.lv && st.locQty > 0);
    var hint = $('[data-number-hint]');
    if (hint) hint.textContent = c.main ? 'Facultatif. Seulement si cet emplacement est ajout\u00e9 \u00e0 un AI Phone que le client poss\u00e8de d\u00e9j\u00e0.' : 'Obligatoire. Demandez au client le num\u00e9ro de t\u00e9l\u00e9phone de l\u2019AI Phone qu\u2019il poss\u00e8de d\u00e9j\u00e0.';
  }

  function msg(text, kind) { var m = $('[data-msg]'); if (!m) return; m.textContent = text || ''; m.className = 'wbs-msg' + (kind ? ' ' + kind : ''); }

  function attributes(c) {
    var a = window.wbAttribution ? window.wbAttribution() : {};
    if (st.locQty > 0 && st.number.trim()) a['Existing AI Phone number'] = st.number.trim();
    return a;
  }
  function validate(c) {
    if (!c.items.length) { msg('Choisissez au moins un produit.', 'err'); return false; }
    if (!c.main && st.locQty > 0 && !st.number.trim()) { msg('Entrez le num\u00e9ro de t\u00e9l\u00e9phone de l\u2019AI Phone existant du client.', 'err'); var n = $('input[name="number"]'); if (n) n.focus(); return false; }
    return true;
  }

  function addToCart() {
    var c = current(); if (!validate(c)) return;
    msg('Adding…');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: c.items }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        var a = attributes(c);
        if (!Object.keys(a).length) return;
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: a }) });
      })
      .then(function () { location.href = '/cart'; })
      .catch(function () { msg('D\u00e9sol\u00e9, impossible de l\u2019ajouter. Veuillez r\u00e9essayer.', 'err'); });
  }

  function copyLink() {
    var c = current(); if (!validate(c)) return;
    var path = c.items.map(function (i) { return i.id + ':' + i.quantity; }).join(',');
    var q = new URLSearchParams(), a = attributes(c);
    Object.keys(a).forEach(function (k) { q.set('attributes[' + k + ']', a[k]); });
    q.set('return_to', '/cart');
    var url = location.origin + '/cart/' + path + '?' + q.toString();
    var done = function () { msg('Lien de commande copi\u00e9. Envoyez-le \u00e0 votre client.', 'ok'); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copiez ce lien de commande\u00a0:', url); });
    else window.prompt('Copiez ce lien de commande\u00a0:', url);
  }

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'phone') st.phone = t.value;
    else if (t.name === 'sms') st.sms = t.checked;
    else if (t.name === 'orbit') st.orbit = t.checked;
    else if (t.name === 'loctype') st.locType = t.value;
    render();
  });
  root.addEventListener('input', function (e) { if (e.target.name === 'number') st.number = e.target.value; });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    if (b.hasAttribute('data-loc-minus')) { st.locQty = Math.max(0, st.locQty - 1); render(); }
    else if (b.hasAttribute('data-loc-plus')) { st.locQty = Math.min(99, st.locQty + 1); render(); }
    else if (b.hasAttribute('data-add')) addToCart();
    else if (b.hasAttribute('data-copy')) copyLink();
  });
  render();
})();
